/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-date': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M4.12 3.75a.38.38 0 01-.37-.37v-3a.38.38 0 11.75 0v3a.38.38 0 01-.38.37zm10.13-.37v-3a.38.38 0 10-.75 0v3a.38.38 0 00.75 0zM18 6V4.12a2.63 2.63 0 00-2.62-2.62H15v1.88a1.13 1.13 0 01-2.25 0V1.5h-7.5v1.88a1.13 1.13 0 01-2.25 0V1.5h-.38A2.63 2.63 0 000 4.12V6zm0 .75v8.63A2.63 2.63 0 0115.38 18H2.62A2.63 2.63 0 010 15.38V6.75zM8 12.38a2.25 2.25 0 10-3.5-1.88.38.38 0 10.75 0 1.5 1.5 0 111.5 1.5H5.62a.38.38 0 000 .75h1.13a1.5 1.5 0 11-1.5 1.5.38.38 0 00-.75 0A2.25 2.25 0 108 12.38zm4.76-3.75a.38.38 0 00-.64-.27l-1.5 1.5a.37.37 0 00.53.53l.85-.86v6.6a.38.38 0 00.75 0z"/>'
  }
})
